var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 65,
    viewBox: "0 0 65 65",
    width: 65,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#5a5a5a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.9,
    cy: 32.1,
    r: 23.4,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.4 6.3c19.4 12 19.4 39.5 0 51.6m-31-51.7c-19.4 12.1-19.4 39.6 0 51.8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.7 45.5h-4.7l-7-10.5h-4v10.5h-4v-26.8h7c12.5-.6 12.4 14 4.2 15.2l8.3 11.5zm-12.4-23.7h-3.6v10h3.3c8.4 0 8.7-10 .3-10z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m43.7 45.5h-4.7l-6.3-9.5v-4.3c6.4-1.2 6.5-9 0-9.8v-3.3c11 .6 10.6 14 2.8 15.2l8.3 11.5zm-11-9.5-1-1h-4v10.5h-3.5v-26.8h8.4v3.3c-.4-.2-1-.2-1.3-.2h-3.6v10h4.8v4.2z",
    fill: "#d2d2d2",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRet);
export default __webpack_public_path__ + "static/media/ret.aec46e36ad86411b312a2189146c2b0a.svg";
export { ForwardRef as ReactComponent };